import { lazy } from 'react';
export const LazyLoginPage = lazy(() => import('./login.page'));
export const LazyForgotPasswordPage = lazy(() => import('./forgot-password.page'));
export const LazyFirstLoginPage = lazy(() => import('./first-login.page'));
export const LazyResetPasswordPage = lazy(() => import('./reset-password.page'));
